export default __webpack_public_path__ + "static/media/bg_payment_page.4ad6a861.png";